import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import classNames from 'classnames';
import ReactDropzone from 'react-dropzone';
import * as _ from 'lodash';
import styles from '../../styles/forms/attachment_wizard/AttachmentForm.scss';
import Button from '../../components/Button';
import Textarea from '../../components/Textarea';
import { __, mapStateToProps } from '../../core/utils';
import UploadIcon from '../../assets/images/upload-40x40.svg';
import CloseSmallIcon from '../../assets/images/close-small-15x15.svg';

@reduxForm({
  form: 'attachment_wizard.upload_attachment_version',
})
@mapStateToProps((state) => ({
  values: getFormValues('attachment_wizard.upload_attachment_version')(state),
}))
class UploadAttachmentVersionForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      drag: false,
    };
  }

  _handleDrop(files) {
    this.setState({ drag: false });

    if (!_.isEmpty(files)) {
      this.props.change('file', files[0]);
    }
  }

  render() {
    const { attachment, values } = this.props;
    const selected_file = _.get(values, 'file');
    const attachment_title = attachment.title || attachment.name;
    const attachment_ext = _.trimStart(attachment.ext || '', '.');
    const file_to_replace = _.filter([
      attachment_title,
      attachment_ext &&
      !_.endsWith(
        _.toLower(attachment_title || ''),
        '.' + _.toLower(attachment_ext),
      )
        ? attachment_ext.toUpperCase()
        : null,
    ]).join('.');

    return (
      <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        <div className={styles.form}>
          <div className={styles.fileToReplace}>
            <span>
              {__('attachments.upload-version.file-to-replace')}
            </span>
            <strong>{file_to_replace}</strong>
          </div>

          <Field
            name='description'
            component={Textarea}
            rows={4}
            maxRows={8}
            label={__('attachments.form.description')}
          />

          {selected_file && (
            <div className={styles.selectedFile}>
              <span>{selected_file.name}</span>
              <CloseSmallIcon onClick={() => this.props.change('file', null)} />
            </div>
          )}

          {!selected_file && (
            <ReactDropzone
              className={classNames(
                styles.dropzone,
                this.state.drag && styles.drag,
              )}
              onDrop={(files) => this._handleDrop(files)}
              onDragOver={() => this.setState({ drag: true })}
              onDragLeave={() => this.setState({ drag: false })}
              multiple={false}
            >
              <UploadIcon />
              <span className={styles.dropTitle}>
                {__('dropzone.title.drop-your-file-here')}
              </span>
              <span className={styles.dropSubtitle}>
                {__('dropzone.title.or-select')}
              </span>
            </ReactDropzone>
          )}
        </div>
        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={this.props.onClose}
          />
          <Button
            lightBlue
            medium
            right
            submit
            disabled={!selected_file}
            middleText={__('attachments.button.upload-new-version')}
            spinning={this.props.submitting}
          />
        </div>
      </Form>
    );
  }
}

export default UploadAttachmentVersionForm;
